"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const GoogleLogo = (_a) => {
    var { scale } = _a, props = __rest(_a, ["scale"]);
    return (react_1.default.createElement("svg", Object.assign({ width: 19 * scale, height: 20 * scale, viewBox: "0 0 19 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#prefix__clip0)" },
            react_1.default.createElement("path", { d: "M19 10.23c0-.68-.053-1.364-.168-2.032H9.69v3.85h5.236a4.64 4.64 0 01-1.938 3.04v2.498h3.124C17.946 15.844 19 13.272 19 10.23z", fill: "#4285F4" }),
            react_1.default.createElement("path", { d: "M9.69 20c2.615 0 4.82-.886 6.425-2.414l-3.123-2.499c-.869.61-1.99.955-3.298.955-2.528 0-4.672-1.76-5.442-4.126H1.03v2.576C2.675 17.869 6.026 20 9.691 20z", fill: "#34A853" }),
            react_1.default.createElement("path", { d: "M4.249 11.916a6.17 6.17 0 010-3.829V5.513h-3.22a10.293 10.293 0 000 8.98l3.22-2.576z", fill: "#FBBC04" }),
            react_1.default.createElement("path", { d: "M9.69 3.958a5.18 5.18 0 013.719 1.499l2.767-2.855A9.159 9.159 0 009.69 0C6.026 0 2.675 2.131 1.029 5.512l3.22 2.576c.765-2.37 2.913-4.13 5.442-4.13z", fill: "#EA4335" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "prefix__clip0" },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 0h19v20H0z" })))));
};
exports.default = GoogleLogo;
